import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import { Button } from "@mui/material";
import Icon from "@mui/material/Icon";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  btn: {
    width: "100%",
    padding: "5px 12px",
    fontWeight: 600,
    fontSize: 12,
    "&:hover": {
      backgroundColor: theme.palette.primary.alt,
    },
    marginTop: 10,
  },
  btnIcon: {
    fontSize: 12,
    marginLeft: 5,
    width: "unset",
    height: "unset",
    overflow: "unset",
  },
}));

const ProductDownload = ({ handleDownloadOnClick }) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.btn}
      variant="contained"
      color="primary"
      size="small"
      onClick={() => handleDownloadOnClick()}
    >
      <FormattedMessage id="sorting.Download" />
      <Icon className={clsx(["fa fa-file-download", classes.btnIcon])} />
    </Button>
  );
};

ProductDownload.propTypes = {
  handleDownloadOnClick: PropTypes.func.isRequired,
};

export default ProductDownload;
